import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-section-form',
  templateUrl: 'section-form.component.html',
  styleUrls: ['section-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SectionFormComponent {
  @Input() selectedSectionInfo: any;

  @Output() clickDeleteSection = new EventEmitter<any>();

  /**
   * Creates an instance of SectionFormComponent.
   * @memberof SectionFormComponent
   */
  constructor(
  ) { }
}
